export default __webpack_public_path__ + "static/media/Sosun Pattah of the Endless Sands.c6a1d3ce.jpg";